import { template as template_aaa65db71c89403c973dcf7172003837 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import moment from 'moment-timezone';
import { runTask, cancelTask } from 'ember-lifeline';
import { service } from '@ember/service';
import { isTesting, macroCondition } from '@embroider/macros';
export default class TimeSince extends Component {
    @service
    intl;
    @tracked
    currentTime;
    timer = null;
    constructor(){
        super(...arguments);
        this.startTimer();
    }
    willDestroy() {
        super.willDestroy(...arguments);
        this.endTimer();
    }
    startTimer() {
        this.incrementTime();
    }
    incrementTime() {
        this.currentTime = moment();
        if (macroCondition(!isTesting())) {
            this.timer = runTask(this, ()=>{
                this.incrementTime();
            }, 30_000);
        }
    }
    endTimer() {
        if (this.timer != null) {
            cancelTask(this, this.timer);
        }
    }
    get message() {
        const minutesDiff = this.currentTime.diff(this.args.lastEvent, 'minutes');
        if (minutesDiff < 1) {
            return `${this.args.labelPrefix}: ${this.intl.t('lessThanAMinute')}`;
        }
        if (minutesDiff === 1) {
            return `${this.args.labelPrefix}: ${minutesDiff} ${this.intl.t('minute')}`;
        }
        if (minutesDiff < 61) {
            return `${this.args.labelPrefix}: ${minutesDiff} ${this.intl.t('minutes')}`;
        }
        return `${this.args.labelPrefix}: ${this.intl.t('overAnHour')}`;
    }
    static{
        template_aaa65db71c89403c973dcf7172003837(`
    <span class="test-time-since fs-4">{{this.message}}</span>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
